// Side-effect module: registers the fcose layout extension exactly once
// (ES module caching means this body runs only the first time it's
// imported, regardless of how many components import it). fcose replaces
// cose for graph layout — it's fast enough at 1000+ nodes to run a full
// relayout without blocking the UI, and supports true incremental
// positioning (randomize: false keeps existing nodes anchored while placing
// only newly-added ones), which cose's per-batch subset trick could not do
// cleanly.
import cytoscape from 'cytoscape';
import fcose from 'cytoscape-fcose';

cytoscape.use(fcose);
